import React from "react";
import { Link } from "react-router-dom";

import INFO from "../../data/user";

import "./styles/logo.css";

const Logo = (props) => {
	let { width, link } = props;

	if (link === undefined) {
		link = true;
	}

	const imageElement = (
		<img
			src={INFO.main.logo}
			srcSet={INFO.main.logoSrcSet}
			sizes={`${width}px`}
			alt="Lunexa Labs"
			className="logo"
			width={width}
			height={width}
			decoding="async"
		/>
	);

	return (
		<React.Fragment>
			{link ? <Link to="/">{imageElement}</Link> : imageElement}
		</React.Fragment>
	);
};

export default Logo;
